var _defs, _rect, _g, _path, _g2, _g3, _path2, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileWebDevelopment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 540 340",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}.c{fill:#fc5e56;}.d{fill:#414a59;}.e{fill:#c2ebff;}.f{fill:#798491;}.g{fill:#e3f6ff;}.h{fill:#bedafc;}.i{fill:#64c4ff;}.j{fill:#3b4956;}.k{fill:#fe9e80;}.l{fill:#4cb7ed;}.m{fill:#27a2cc;}.n{fill:#ffc931;}.o{fill:#f4bb2a;}.p{opacity:.1;}.q{fill:#d3a900;}.r{fill:#b4e7fc;}.s{fill:#593838;}.t{fill:#b1d8e5;}.u{fill:#f0736d;}.v{fill:#282f39;}.w{fill:#4bb3db;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 540,
    height: 340
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M114.22,124.65s5.01-42.44-19.13-61.51c0,0-15.97-12.19-13.53,2,0,0,.75,5.56-7.64-.32-6.95-4.86-17.41-11.67-23.35-4.98-6.96,7.85,17.9,21.5,17.9,21.5,0,0,10.68,7-9.34,4.07-6.69-.98-4.37,23.06,48.38,38.33l6.7,.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M111.27,121.2c-.11,.05-.24,0-.3-.1-11.97-24.33-26.14-38.92-35.93-46.87-10.6-8.62-18.47-11.51-18.55-11.54-.12-.04-.18-.17-.14-.29,.04-.12,.17-.18,.29-.14,.08,.03,8.01,2.95,18.66,11.6,9.83,7.98,24.06,22.62,36.07,47.04,.05,.11,0,.25-.1,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M92.33,88.41c-.06,.03-.12,.03-.18,0-.11-.05-.17-.18-.12-.29,5.17-12.58-4.59-23.98-4.69-24.1-.08-.09-.07-.24,.02-.32,.09-.08,.24-.07,.32,.02,.03,.03,2.55,2.95,4.38,7.41,1.7,4.12,3.14,10.45,.38,17.16-.02,.05-.06,.09-.11,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.2,93.96c-4.88,2.35-9.79,2.61-13.36,2.32-4.87-.39-8.37-1.85-8.4-1.87-.11-.05-.17-.18-.12-.29,.05-.11,.18-.17,.29-.12,.14,.06,13.8,5.68,25.08-2.68,.1-.07,.24-.05,.31,.05,.07,.1,.05,.24-.05,.31-1.24,.92-2.5,1.67-3.77,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M102.73,101.37c-.08,.04-.17,.03-.24-.03-.1-.08-.11-.22-.04-.32,5.26-6.58,2.95-14.28,2.93-14.36-.04-.12,.03-.24,.15-.28,.12-.04,.24,.03,.28,.15,.02,.08,2.4,8-3.01,14.77-.02,.03-.05,.05-.08,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M93.75,108.12c-3.03,1.46-5.63,1.99-7.54,2.14-3.22,.25-5.15-.46-5.23-.49-.12-.04-.17-.17-.13-.29,.04-.12,.17-.17,.29-.13,.08,.03,7.74,2.79,17.68-4.93,.1-.08,.24-.06,.32,.04,.08,.1,.06,.24-.04,.32-1.88,1.46-3.68,2.54-5.35,3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.18,71.85s-.02,0-.03,.01c-.12,.04-.24-.03-.28-.14-2.01-6.2-6.7-8.64-6.74-8.67-.11-.06-.15-.19-.1-.3,.06-.11,.19-.15,.3-.1,.05,.02,4.9,2.55,6.97,8.93,.04,.11-.02,.22-.12,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.77,75.15h-.02c-3.76,1.43-6.84,1.24-8.77,.84-2.1-.44-3.29-1.2-3.34-1.24-.1-.07-.13-.21-.07-.31,.07-.1,.21-.13,.31-.07,.05,.03,4.73,2.99,11.7,.36,.12-.04,.25,.01,.29,.13,.04,.11,0,.23-.11,.28Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M119.49,297.23c-17.32,1.43-35.58-1.21-49.89-10.49-14.31-9.28-23.8-26.02-20.73-42.11,3.69-19.33,23.37-32.97,28.48-52.02,5.17-19.25-15.98-28.07-15.27-46.3,.39-10.08,6.63-19.8,15.93-24.83,6.59-3.56,14.28-4.79,21.36-7.37,20.48-7.45,15.02-25.56,22.32-41.41,6.49-14.11,22.76-22.94,39.08-23.87,16.32-.93,32.44,5.1,45.7,14.1,12.64,8.57,26.56,20.61,41.42,16.19,10.43-3.1,15.55-14.47,25.36-19.16,10.2-4.88,22.14-5.79,33.18-3.79,9.85,1.78,18.92,6.12,27.79,10.61,8.19,4.15,16.83,9.67,25.94,11.1,13.45,2.12,27.43,.62,40.16-4.17,13.3-5.01,24.83-13.2,38.81-16.83,16.74-4.35,34.97-1.68,44.9,12.99,6.96,10.27,8.37,23.08,7.4,35.22-1.91,24.11-12.67,47.51-30.03,65.34-4.77,4.9-10.04,9.42-13.96,14.94-6.98,9.84-5.9,19.65,.42,29.51,9.67,15.07,33.64,25.19,25.91,46.08-5.1,13.78-22.66,17.34-35.62,17.69-18.54,.5-33.97-2.31-50.53,8.89-9.59,6.49-17.04,15.67-26.13,22.84-18.8,14.82-44.02,10.5-65.13,2.96-21.97-7.84-42.11-17.62-65.21-21.97-18.81-3.55-38.08-4.71-57.18-3.4-18.18,1.24-36.67,9.25-54.49,9.25Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M333.92,192.8s56.61,9.97,84.04-20.99c0,0,17.59-20.51-1.65-18.32,0,0-7.52,.59,1.01-10.23,7.06-8.96,17-22.49,8.46-30.97-10.01-9.94-30.23,22.4-30.23,22.4,0,0-10.21,13.81-4.75-12.85,1.83-8.91-30.62-7.62-55.15,62.04l-1.73,8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M338.78,189.11c-.06-.15,0-.33,.16-.39,33.58-14.21,54.25-32.14,65.67-44.67,12.38-13.58,16.87-23.93,16.91-24.03,.07-.15,.24-.22,.4-.16,.15,.07,.23,.24,.16,.4-.04,.1-4.57,10.53-17,24.18-11.47,12.59-32.21,30.58-65.91,44.84-.15,.07-.33,0-.4-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M384.25,166.18c-.03-.08-.03-.17,0-.25,.07-.15,.25-.21,.4-.14,16.5,7.91,32.55-4.33,32.71-4.46,.13-.1,.32-.08,.42,.05,.1,.13,.08,.32-.05,.42-.04,.03-4.15,3.2-10.28,5.32-5.67,1.96-14.27,3.42-23.07-.8-.07-.03-.12-.09-.15-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M377.34,156.18c-2.78-6.73-2.75-13.34-2.1-18.12,.9-6.5,3.13-11.09,3.15-11.14,.07-.15,.25-.21,.4-.14,.15,.07,.21,.25,.14,.4-.09,.18-8.69,18.1,1.68,33.89,.09,.14,.05,.33-.09,.42-.14,.09-.33,.05-.42-.09-1.14-1.73-2.05-3.48-2.77-5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M366.06,179.15c-.04-.1-.03-.23,.05-.32,.11-.12,.3-.13,.43-.02,8.43,7.56,18.95,5.05,19.06,5.03,.16-.04,.33,.06,.37,.22,.04,.16-.06,.33-.22,.37-.11,.03-10.93,2.61-19.61-5.16-.03-.03-.06-.07-.08-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M357.68,166.58c-1.73-4.18-2.24-7.72-2.29-10.29-.1-4.34,1.01-6.88,1.06-6.99,.07-.15,.25-.22,.4-.15,.15,.07,.22,.25,.15,.4-.04,.1-4.33,10.18,5.26,24.12,.09,.14,.06,.33-.08,.42-.14,.09-.33,.06-.42-.08-1.82-2.64-3.14-5.13-4.09-7.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M407.8,144.4s0-.03-.01-.04c-.04-.16,.05-.33,.22-.37,8.48-2.23,12.12-8.33,12.15-8.39,.08-.14,.27-.19,.41-.11,.14,.08,.19,.27,.11,.41-.04,.06-3.8,6.38-12.52,8.67-.15,.04-.3-.04-.36-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M403.48,142.26v-.03c-1.63-5.15-1.15-9.28-.46-11.84,.75-2.78,1.87-4.32,1.92-4.39,.1-.13,.29-.16,.42-.06,.13,.1,.16,.29,.06,.42-.04,.06-4.37,6.12-1.37,15.69,.05,.16-.04,.33-.2,.38-.15,.05-.31-.03-.37-.17Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M361.56,60.77c-18.89,29.03-97.12,55.46-43.41,126.15,.14,.18,.38,.26,.59,.21,85.9-22.39,40.73-91.51,43.81-126.01,.05-.57-.68-.82-.99-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M315.18,174.39c19.1-20.63,40.74-95.77,40.96-96.52l.77,.22c-.22,.76-21.91,76.08-41.14,96.85l-.59-.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M348.61,111.25c-.04-.07-.07-.16-.06-.26,.01-.25,.23-.45,.48-.43,.07,0,6.8,.3,12.99-4.63,.2-.16,.49-.12,.64,.07,.16,.19,.13,.49-.07,.64-6.47,5.15-13.32,4.84-13.61,4.82-.16,0-.3-.1-.37-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M337.17,101.67c-1.87-3.2-2.33-5.74-2.36-5.92-.04-.25,.12-.49,.37-.53,.25-.04,.48,.12,.53,.37,.01,.07,1.3,7.01,8.19,12.33,.2,.15,.24,.44,.08,.64-.15,.2-.44,.24-.64,.08-2.93-2.26-4.88-4.77-6.17-6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M342.36,128.09c-.04-.07-.07-.16-.06-.26,.01-.25,.23-.45,.48-.43,.09,0,9.61,.43,18.35-6.53,.2-.16,.49-.12,.64,.07,.16,.19,.13,.49-.07,.64-9.03,7.19-18.87,6.74-18.97,6.73-.16,0-.3-.1-.37-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M336.09,144.18c-.05-.09-.08-.2-.05-.32,.05-.25,.29-.41,.53-.36,.11,.02,11.6,2.09,23.23-6.22,.21-.15,.49-.1,.64,.11,.14,.2,.1,.49-.11,.64-11.96,8.55-23.81,6.39-23.93,6.37-.13-.03-.24-.11-.31-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M318.49,129.69c-1.34-2.3-2.56-4.95-3.5-7.99-.07-.24,.06-.5,.3-.57,.24-.08,.5,.06,.57,.3,4.38,14.12,14.89,19.72,14.99,19.78,.22,.12,.31,.39,.2,.62-.12,.22-.39,.31-.62,.2-.09-.04-6.88-3.66-11.94-12.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M328.69,116.7c-2.37-4.06-3.07-7.31-3.08-7.37-.05-.25,.11-.49,.36-.54,.25-.05,.49,.11,.54,.36,.02,.09,2.03,9.4,10.98,16.09,.2,.15,.24,.44,.09,.64-.15,.2-.44,.24-.64,.09-3.9-2.91-6.52-6.31-8.25-9.27Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M347.17,262.29l-93.26,20.28c-5.51,1.2-10.95-2.3-12.14-7.81l-38.28-176.04c-1.2-5.51,2.3-10.95,7.81-12.14l93.26-20.28c5.51-1.2,10.95,2.3,12.14,7.81l38.28,176.04c1.2,5.51-2.3,10.95-7.81,12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M346.68,248.91l-97.89,21.29c-1.12,.24-2.22-.47-2.46-1.58l-36.13-166.17c-.24-1.12,.47-2.22,1.58-2.46l97.89-21.29c1.12-.24,2.22,.47,2.46,1.58l36.13,166.17c.24,1.12-.47,2.22-1.58,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M307.94,265.95l-16.83,3.66c-.99,.21-1.96-.41-2.18-1.4h0c-.21-.99,.41-1.96,1.4-2.18l16.83-3.66c.99-.22,1.96,.41,2.18,1.4h0c.21,.99-.41,1.96-1.4,2.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M266.54,82.92l-20.44,4.44c-.85,.18-1.68-.35-1.87-1.2h0c-.18-.85,.35-1.68,1.2-1.87l20.44-4.44c.85-.18,1.68,.35,1.87,1.2h0c.18,.85-.35,1.68-1.2,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M274.41,79.61c.18,.85-.35,1.68-1.2,1.87-.85,.18-1.68-.35-1.87-1.2s.35-1.68,1.2-1.87c.85-.18,1.68,.35,1.87,1.2Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M296.87,118.62l.03-.02,.06,.28,16.72,76.91c.43,1.95-.25,3.88-1.59,5.19h0c-.24,.23-.49,.44-.75,.62-.07,.06-.17,.09-.25,.15-.21,.12-.41,.25-.65,.35-.32,.13-.66,.25-1.03,.33l-19.24,4.18,6.19,28.47,28.78,18.5,21.54-4.68c1.12-.24,1.83-1.35,1.58-2.46l-1.3-5.98-.53-2.42-22.55-103.72-28.83-18.53c.86,.71,1.51,1.68,1.81,2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M300.55,120.98c-.31-1.14-.96-2.11-1.81-2.82l-1.19-.76c-.46-.22-.95-.38-1.46-.47,.35,.51,.62,1.07,.79,1.69l.03-.02,.06,.28,16.72,76.91c.43,1.95-.25,3.88-1.59,5.19h0c-.24,.23-.49,.44-.75,.62-.07,.06-.17,.09-.25,.15-.21,.12-.41,.25-.65,.35-.32,.13-.66,.25-1.03,.33l-19.24,4.18,6.19,28.47,3.68,2.36-6.19-28.47,19.24-4.18c.36-.08,.7-.2,1.03-.33,.23-.11,.44-.23,.65-.35,.08-.05,.18-.09,.25-.15,.27-.18,.52-.4,.75-.61h0c1.35-1.33,2.02-3.25,1.59-5.21l-16.72-76.91-.06-.28-.03,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M296.87,118.62c-.4-1.47-1.35-2.66-2.6-3.37-1.16-.68-2.55-.95-3.97-.65h0l-117.13,25.47h-.01c-1.37,.3-2.5,1.11-3.28,2.15,0,0,0,.02-.01,.02,0,.02-.03,.03-.05,.06h.02c-.45,.62-.77,1.32-.94,2.07,0,.06,0,.13-.02,.19-.06,.32-.1,.64-.11,.97,0,.31,.04,.62,.09,.93h-.04l.06,.27,16.72,76.91c.35,1.6,1.39,2.86,2.71,3.62l-.02,.02c.05,.03,.11,.05,.16,.07,.02,.01,.04,.03,.06,.04h0c1.12,.57,2.42,.81,3.74,.53l74.17-16.13,29.93,23.3-6.19-28.47,19.24-4.18c.36-.08,.7-.2,1.03-.33,.23-.11,.44-.23,.65-.35,.08-.06,.18-.09,.25-.15,.27-.18,.52-.4,.75-.61h0c1.35-1.33,2.02-3.25,1.59-5.21l-16.72-76.91-.06-.28-.03,.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M208.87,207.74c.59,.41,1.28,.59,1.97,.44l68.77-14.95c1.47-.32,2.37-2.01,1.99-3.75l-9.7-44.62c-.2-.93-.73-1.68-1.4-2.14l-30.47,34.1-31.16,30.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M208.98,207.81l31.05-30.99-41.85-18.41c-.43,.7-.62,1.63-.41,2.57l9.7,44.62c.21,.97,.79,1.76,1.51,2.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M208.87,207.74c.59,.41,1.28,.59,1.97,.44l68.77-14.95c.69-.15,1.25-.61,1.61-1.22l-41.19-15.19-31.16,30.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M240.03,176.82l-41.85-18.41c-.43,.7-.62,1.63-.41,2.57l.7,3.21,37.28,20.15c1.83,.99,4,1.28,6.1,.82,2.11-.46,3.96-1.62,5.21-3.28l25.54-33.81-.7-3.21c-.2-.93-.73-1.68-1.4-2.14l-30.47,34.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M240.03,176.82l30.47-34.1c-.59-.41-1.28-.59-1.97-.44l-68.77,14.95c-.69,.15-1.25,.61-1.61,1.22l41.88,18.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M270.5,142.72c-.59-.41-1.28-.59-1.97-.44l-68.77,14.95c-.69,.15-1.25,.61-1.61,1.22h0s-.03,.07-.05,.1l39.92,21.58c1.7,.92,4.05,.41,5.21-1.13l27.36-36.21s-.06-.05-.08-.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M283.15,141.9c1.68,7.75-3.23,15.4-10.98,17.08-7.75,1.68-15.4-3.23-17.08-10.98-1.68-7.75,3.23-15.4,10.98-17.08,7.75-1.69,15.4,3.23,17.08,10.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M270.63,153.89c-.29,.06-.58-.12-.64-.42l-2.6-12.11c-.06-.3-.37-.5-.66-.43-.11,.02-.21,.08-.29,.17l-1.77,2.18c-.08,.1-.18,.16-.31,.19-.16,.03-.33,0-.46-.11l-1.15-.94c-.11-.09-.18-.22-.2-.36-.01-.14,.03-.28,.12-.4l4.11-5.01c.08-.09,.19-.16,.3-.19l2.11-.45c.29-.06,.58,.12,.64,.42l3.5,16.32c.06,.29-.12,.58-.42,.64l-2.31,.5Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M329,47.62c-.75,0-1.43-.43-1.73-1.1-3.12-6.87-9.27-10.97-16.45-10.97-2.42,0-4.85,.48-7.23,1.42-.22,.09-.45,.13-.69,.13-.83,0-1.56-.54-1.82-1.33l-.03-.1c-.3-.93,.15-1.96,1.03-2.34,3.04-1.33,6.16-2.01,9.27-2.01,8.57,0,16.06,5.22,19.53,13.61,.37,.89-.02,1.95-.88,2.4l-.1,.05c-.28,.15-.59,.23-.91,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M319.93,53.42c-.7,0-1.36-.4-1.73-1.03-1.8-3.14-4.97-5.01-8.47-5.01-.97,0-1.95,.14-2.92,.42-.19,.06-.39,.08-.59,.08-.85,0-1.59-.53-1.85-1.31l-.05-.16c-.32-.99,.2-2.04,1.18-2.4,1.58-.58,3.18-.87,4.78-.87,4.94,0,9.24,2.78,11.51,7.42,.46,.94,.1,2.06-.81,2.55l-.16,.08c-.28,.15-.58,.22-.88,.22Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M92.85,272.96h3.21l7.01-18.45h25.24l-7.01,18.45h3.21l45.79-120.59h-3.21l-3.29,8.66h-25.24l3.29-8.66h-3.21l-3.29,8.66h-.11v.29l-42.4,111.64Zm64.08-93.84h-25.24l5.73-15.1h25.24l-5.73,15.1Zm-6.87,18.1h-25.24l5.73-15.1h25.24l-5.73,15.1Zm-6.87,18.1h-25.24l5.73-15.1h25.24l-5.73,15.1Zm-6.87,18.1h-25.24l5.73-15.1h25.24l-5.73,15.1Zm-32.11,18.1l5.73-15.1h25.24l-5.73,15.1h-25.24Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M60.37,151.64c-.27,0-.52-.1-.71-.29l-3.58-3.59c-.39-.39-.39-1.03,0-1.42,.19-.19,.44-.29,.71-.29s.52,.1,.71,.29l2.32,2.32c.15,.15,.35,.23,.56,.23s.41-.08,.56-.23l5.9-5.9c.19-.19,.44-.29,.71-.29s.52,.1,.71,.29c.39,.39,.39,1.03,0,1.42l-7.17,7.17c-.19,.19-.44,.29-.71,.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M62.16,164.18c-9.45,0-17.14-7.69-17.14-17.14s7.69-17.14,17.14-17.14,17.14,7.69,17.14,17.14-7.69,17.14-17.14,17.14Zm0-32.26c-8.34,0-15.13,6.79-15.13,15.13s6.79,15.13,15.13,15.13,15.13-6.79,15.13-15.13-6.79-15.13-15.13-15.13Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 419.13,
    y: 259.6,
    width: 2.75,
    height: 3.65,
    transform: "translate(915.39 245.39) rotate(146.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M402.71,212.08s2.92-1.88,7.26,29.62c.09,.66,.03,1.41,.43,1.94,4.24,5.61,9.21,12.43,11.97,17.8l-2.28,2.01-16.79-18.54-9.8-28.97,9.2-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M369.03,197.28c.33-.01,1.89,.09,2.16-.07,.36-.2-.01-.23,.16-.61,.13-.28-.39-1.08-.41-1.42-.05-1.11-.98-1.96-2.09-1.91s-2.92-1.42-2.88-.32c.05,1.1,1.95,4.37,3.05,4.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "384.46 189.45 378.12 199.73 371.4 195.4 369.62 198.14 378.75 205.93 385.5 198.04 384.46 189.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "369.48 195.76 373.22 195.6 369.37 191.38 365.63 191.53 369.48 195.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M393.04,183.81s-8.37,.61-9.11,7.6,.64,25.1,.64,25.1c0,0-.21,5.3,4.45,7.52l4.77-16.74-.74-23.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 390.19,
    y: 264.92,
    width: 2.75,
    height: 3.65,
    transform: "translate(783.13 533.5) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M397.81,208.68s2.42,2.23-4.88,59.64l-2.91,.11-2.35-58.99,10.14-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M406.29,193.95s1.91-5.48-1.59-7.86c-3.5-2.38-13.57-2.6-16.58,1.85-2.78,4.1-1.21,20.89-.58,28.68,0,0,9.96,2.22,19.49-.64,0,0-2.33-8.84-.74-22.03Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M392.8,179.4s.5,2.93-.68,6.08c-1.36,3.66,5.7,3.03,6.58,1.08,0,0,.45-.61-.21-1.79-.66-1.18-2.07-5.97-.48-8.55l-5.21,3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M392.71,183.25c.25-1.49,.2-2.74,.14-3.38l.75-.46,3.87-1.84c-.12,.51-.18,1.04-.2,1.59-.67,1.34-2.16,3.18-4.57,4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M388.58,175.77c.85,3.49,3.29,5.9,5.47,5.37,2.17-.53,4.7-4.54,3.85-8.04-.85-3.49-4.74-5.14-6.92-4.61-2.17,.53-3.25,3.78-2.4,7.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M386.9,172.33s.13,2.01,7.39-.95c0,0,1.97-.78,1.71,4.08l.62,.64s-.04-2.01,.81-1.68c.84,.33,.7,1.22,.03,3.09,0,0-.03,1.31,.24,1.74,0,0,2.54,.46,1.1-2.51,0,0,3.79-7.88-2.23-8.09,0,0-8.36-2.33-9.66,3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M398.23,183.89s-2.22,3.92-.95,14.19l1.48,16.15s.08,7.79,5.72,8.34h5.08s-2.86-19.83-2.65-31.38c0,0,.53-7.63-8.69-7.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 409.99,
    y: 212.82,
    width: 2.15,
    height: 3.24,
    transform: "translate(757.19 522.93) rotate(-165.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M412.43,217.84c.29-1.15-.41-2.32-1.56-2.61s-2.32,.41-2.61,1.56c-.29,1.15,.41,2.32,1.56,2.61,1.15,.29,2.32-.41,2.61-1.56Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "403.88 192.75 411.79 199.85 409.66 213.82 412.71 214.81 417.46 198.75 405.35 186.42 403.88 192.75"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M392.78,191.84c.67-.16,1.18-.77,1.18-1.49,0-.85-.69-1.54-1.54-1.54s-1.54,.69-1.54,1.54c0,.35,.13,.68,.33,.94-.5,1.46-1.5,5.45-1.07,13.44l1.74,1.51,1.96-1.57s-1.62-8.9-1.05-12.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "392.68 188.74 393.91 192.27 395.46 191.04 394.67 189.1 393.16 188.38 392.68 188.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M392.83,188.84l-2.22,2.07-.85-1.22s.5-1.06,.98-1.11,1.83-.13,1.83-.13l.26,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M421.67,260.64s2.53,.73,2.7,3.67l-8.02,5.35s-1.76-2.83,3.08-5.11l.23-1.65s2.4-.04,2-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M392.97,266.75s1.69,2.01,.21,4.55h-9.64s.11-3.34,5.4-2.54l1.16-1.3s1.97,1.35,2.87-.72Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 196.44,
    y: 111.5,
    width: 2.41,
    height: 3.2,
    transform: "translate(392.37 231.15) rotate(-178.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M198.87,113.13s1.44,1.8,.08,3.99l-8.43-.21s.17-2.92,4.78-2.1l.44-.78s2.3,.89,3.13-.89Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 188.13,
    y: 109.62,
    width: 2.41,
    height: 3.2,
    transform: "translate(375.8 227.19) rotate(-178.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M190.56,111.25s1.44,1.8,.08,3.99l-8.43-.21s.17-2.92,4.78-2.1l.44-.78s2.3,.89,3.13-.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M211.68,69.33c1.34,2.19,4.67,9.08-3.56,12.8-.06,.03-.13,.05-.19,.07l-14.2,3.55c-.43,.11-.74,.48-.77,.91l-1.73,23.07c-.04,.53-.48,.95-1.02,.95h-1.5c-.55,0-1-.43-1.02-.98l-1.05-26.46c-.01-.37,.17-.72,.49-.91l20.3-12.33c.06-.04,.13-.07,.19-.09l2.86-1c.45-.16,.96,.02,1.21,.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M220.96,70.17c1.18,1.82,5.24,9.2-3.41,13.09-.04,.02-.09,.04-.13,.05l-15.67,4.11c-.32,.08-.55,.36-.57,.69l-1.76,23.49c-.03,.4-.37,.71-.77,.71h-1.97c-.41,0-.75-.33-.77-.74l-1.07-26.94c0-.23,.08-.45,.25-.6l13.83-12.53c.12-.1,.26-.17,.41-.19l10.88-1.48c.3-.04,.59,.1,.75,.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M202.99,46.85l-7.58,16.85c-.1,.22-.05,.47,.11,.64l3.39,3.48c.12,.12,.29,.19,.45,.17l2.59-.19c.43-.03,.68-.51,.45-.88l-1.65-2.67c-.1-.17-.11-.38-.02-.56l3.32-6.62c.05-.1,.07-.21,.06-.32l-.78-7.98c-.06-.59-.11-2.47-.35-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M221.9,51.94s1.79-5.15-1.49-7.39c-3.28-2.24-14.32-1.17-16.62,1.02-3.09,2.94-1.37,19.84-.77,27.16,0,0,10.63,1.41,19.59-1.28,0,0-2.19-7.12-.7-19.51Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M209.22,38.26s.47,2.75-.63,5.71c-1.28,3.44,5.35,2.85,6.19,1.02,0,0,.42-.58-.2-1.68-.62-1.11-1.95-5.61-.45-8.04l-4.9,2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M213.44,37.85c.02-.56,.1-1.11,.25-1.61l-4.45,2.2c.02,.14,.04,.35,.05,.63,0,.05,0,.09,0,.14,.03,.68,.01,1.68-.19,2.81-.02,.18-.04,.28-.04,.28,2.58-.71,3.8-2.89,4.37-4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M205.45,34.85c.89,3.28,3.26,5.48,5.3,4.93,2.04-.55,4.32-4.41,3.43-7.69-.89-3.28-4.61-4.73-6.65-4.18-2.04,.55-2.97,3.66-2.08,6.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M202.85,29.51s-.41,3.83,7.87,1.04c0,0,1.84-.78,1.72,3.81l.6,.59s-.09-1.9,.72-1.6,.69,1.14,.11,2.92c0,0-.7,1.36-.43,1.76,0,0,2.54,.42,1.68-2.52,0,0,3.38-7.54-2.31-7.58,0,0-9.17-4.78-9.95,1.59Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "211.53 76.29 219.03 72.05 202.59 71.66 195.38 75.86 211.53 76.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "195.38 75.86 211.53 76.29 209.17 65.77 193.01 65.35 195.38 75.86"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 216.16,
    y: 69.99,
    width: 2.24,
    height: 3.38,
    transform: "translate(204.52 300.11) rotate(-105.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M214.42,73.04c1.94,.73,2.36,.05,2.04-1.14-.32-1.19-1.55-1.9-2.74-1.58-1.19,.32-2.49,1.84-2.17,3.03,.32,1.19,1.72-.75,2.88-.31Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M218.57,53.76l6.65,11.1c.21,.35,.09,.8-.26,1l-7.78,4.54c-.3,.18-.44,.55-.32,.88l.43,1.16c.14,.37,.55,.56,.92,.44l13.84-4.79c.42-.14,.61-.62,.41-1.02l-10.51-20.59c-.27-.53-.51,.6-.77,1.14l-2.64,5.46c-.11,.22-.1,.48,.03,.69Z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 161.5,
    y: 212.05,
    width: 1.61,
    height: 2.44,
    transform: "translate(-83.78 107.12) rotate(-29.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M161.99,215.99c-.44-.78-.16-1.76,.61-2.2,.78-.44,1.76-.16,2.2,.61,.44,.78,.16,1.76-.61,2.2-.78,.44-1.76,.16-2.2-.61Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "167.07 195.56 159.17 202.56 163.26 212.77 161.35 213.63 155.37 202.26 165.06 190.31 167.07 195.56"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 179.72,
    y: 213.1,
    width: 1.61,
    height: 2.44,
    transform: "translate(232.62 489.64) rotate(-150.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M180.84,217.04c.44-.78,.16-1.76-.61-2.2-.78-.44-1.76-.16-2.2,.61-.44,.78-.16,1.76,.61,2.2,.78,.44,1.76,.16,2.2-.61Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "175.76 196.61 183.66 203.61 179.57 213.82 181.48 214.68 187.46 203.31 177.77 191.36 175.76 196.61"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M174.59,177.58c-.27,.1-.54,.22-.79,.36-2.64,1.45-4.26,4.45-5.12,7.23-.51,1.65-.68,3.44-.18,5.09,.49,1.65,1.71,3.13,3.35,3.68,1.63,.55,3.64,.01,4.58-1.43,.71-1.09,.77-2.52,1.52-3.58,.64-.9,1.77-1.58,1.83-2.68,.05-.88-.64-1.63-.77-2.5-.16-1.13,.64-2.19,.7-3.34,.06-1.3-.92-2.5-2.15-2.93-.95-.33-2-.25-2.96,.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M162.01,268.09l.44-.54-.07-2.94h2.01l-.29,2.83s2.44,1.35,2.26,4.56l-1.22,.13s-2.24-3.9-3.13-4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M162.01,268.09s-1.1,1-.19,2.24l.57,2.63h.62l.48-2.48s1.05,.1,.91,2.48h3.29s.53-.62-1.38-1.24l-1-.19s-1.1-2.91-3.29-3.44Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M174.61,268.09l.44-.54-.07-2.94h2.01l-.29,2.83s2.44,1.35,2.26,4.56l-1.22,.13s-2.24-3.9-3.13-4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M174.61,268.09s-1.1,1-.19,2.24l.57,2.63h.62l.48-2.48s1.05,.1,.91,2.48h3.29s.53-.62-1.38-1.24l-1-.19s-1.1-2.91-3.29-3.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M165.02,212.1s-3.69-5.4-2.79,54.4h2.35l7.84-51.93-7.4-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M169.07,213.16s-.2,2.2,5.59,53.35h2.46l2.17-53.49-10.22,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M170.05,191.16c-1.09,.06-2.17,.27-3.21,.62-1.06,.36-2.52,1.18-2.72,2.38-.24,1.48,.29,2.79,.88,4.11,.72,1.61,1.3,3.13,1.81,4.81,.51,1.69,.56,3.64-.42,5.11-.85,1.28-2.07,2.19-2.29,3.72-.12,.87,.53,2.01,2.87,3.31,1.93,1.07,4.1,1.09,6.3,1.09,3.72,0,5.52-1.09,5.92-2.14,.48-1.26,.18-2.69-.29-3.96-.46-1.27-1.08-2.51-1.23-3.86-.39-3.51,2.47-6.96,1.48-10.35-.6-2.03-2.49-3.45-4.48-4.17-1.48-.54-3.07-.76-4.64-.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M174.53,187.36s-.95,2.54,1.02,5.66c1.97,3.12-4.53,3.04-5.37,1.2,0,0-.42-.58,.2-1.69,.63-1.11,1.96-5.63,.46-8.07l3.7,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M171.28,185.55s.83,1.89,3.01,3.35c0,0,.01-.69,.15-1.16l-3.16-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M178.41,182.42c0,3.09-1.56,5.59-3.48,5.59s-4.84-2.84-4.84-5.93,2.92-5.25,4.84-5.25,3.48,2.5,3.48,5.59Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M177.11,177c0,.1,.01,.21,0,.32-.09,1.6-1.74,2.59-3.18,3.3-1.44,.71-3.08,1.72-3.15,3.32-.04,1.04,.62,1.96,.98,2.94,.66,1.8,.18,3.94-1.09,5.35-1.16,1.29-2.72,3.38-4.6,3.4-1.42,.02-2.8-.95-3.26-2.3-.55-1.62,.18-3.39,1.07-4.85,.9-1.46,2.01-2.86,2.31-4.55,.24-1.33-.06-2.72,.28-4.03,.44-1.69,1.87-2.93,3.32-3.91,1.28-.86,2.74-1.64,4.29-1.56,1.44,.08,2.9,1.16,3.02,2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M163.49,190.03c-.78,1.35-.8,3.11-.06,4.49,.74,1.38,2.22,2.32,3.78,2.42,.91,.06,1.81-.16,2.72-.22,1.1-.08,2.2,.05,3.3,.03,1.44-.03,2.9-.33,4.12-1.07,1.23-.75,2.2-1.98,2.42-3.4,.16-1.03-.06-2.09,.09-3.12,.2-1.33,.99-2.8,.23-3.92-.24-.36-.61-.61-.86-.95-.76-1.01-.36-2.45-.61-3.69-.37-1.81-1.35-3.44-3.18-3.71-1.83-.27-4.51,.62-6.27,1.18-1.39,.44-2.05,8.68-4.51,10.87-.54,.26-.96,.76-1.1,1.34l-.06-.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "164.58 266.5 170.41 227.9 169.27 219.16 164.58 266.5"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 133.61,
    y: 209.21,
    width: 2.63,
    height: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M128.34,167.58l6.02,20.38-1.22,25.56,3.18,.12,4.73-25.99s-2.43-24.42-5.47-28.88l-9.53,1.22,2.29,7.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "136.86 135.14 144.5 147.82 153.19 141.77 153.92 143.82 143.77 153.44 135.59 144.15 136.86 135.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M154.88,144.12c-1.13-.05-2-1-1.95-2.13,.05-1.13,1-2,2.13-1.95s2.98-1.45,2.93-.33c-.05,1.13-1.98,4.45-3.11,4.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "154.42 142.57 150.6 142.41 154.52 138.1 158.34 138.26 154.42 142.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 122.1,
    y: 209.21,
    width: 2.63,
    height: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M121.16,154.79s-4.46-3.29,.9,57.09l2.77,.41,5.33-55.22-9-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M119.34,140.37s-1.82-5.24,1.52-7.52c3.34-2.28,12.98-2.48,15.87,1.77,2.66,3.92,1.16,19.99,.55,27.44,0,0-9.53,2.13-18.65-.61,0,0,2.23-8.46,.71-21.08Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M132.25,126.45s-.48,2.8,.65,5.81c1.31,3.5-5.45,2.9-6.3,1.03,0,0-.43-.59,.2-1.72,.63-1.13,1.98-5.71,.46-8.18l4.99,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M127.85,125.02c.08,.46,.11,.94,.11,1.43,.72,1.32,2.06,3.06,4.42,3.9-.26-1.39-.24-2.58-.19-3.27l-4.33-2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M136.3,122.66c-.58,3.52-2.82,6.07-5,5.72-2.19-.36-4.98-4.14-4.4-7.66,.58-3.52,4.31-5.43,6.49-5.07,2.19,.36,3.49,3.5,2.91,7.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M137.7,119.14s-1.03,2.32-7.59,.36c0,0-1.78-1.38-1.17,3.4l-.57,.68s-.11-1.99-.92-1.6c-.81,.39-.6,1.26,.2,3.06h0c-.96-.46-1.24-.93-1.64-1.92-.91-2.24-1.83-7.58,1.83-6.88,0,0,6.73-3.26,9.85,2.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 121.68,
    y: 160.08,
    width: 2.06,
    height: 3.1,
    transform: "translate(-67.63 91.25) rotate(-32.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M122.5,165.12c-.61-.96-.33-2.23,.63-2.84,.96-.61,2.23-.33,2.84,.63,.61,.96,.33,2.23-.63,2.84s-2.23,.33-2.84-.63Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "122.71 139.77 117.66 148.6 124.4 162.25 122.68 163.51 112.18 149.31 119.53 134.73 122.71 139.77"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M120.76,133.16s-2.04,.84-5.42,8.28c0,0,1.32,2.53,4.71,3.81l3.32-3.74s2.26-1.87,2.12-2.3c-.14-.43-1.49-3.27-1.75-3.82-.26-.55-2.98-2.22-2.98-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M135.63,133.53s3.8,3.34,5.52,7.14c0,0-1.49,2.23-4.46,3.45l-2.43-4.76,.71-5.22,.66-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M133.59,210.96s-1.62,1.93-.2,4.36h9.22s-.1-3.19-5.17-2.43l-1.06-1.19s-1.93,1.24-2.79-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M122.07,210.96s-1.62,1.93-.2,4.36h9.22s-.1-3.19-5.17-2.43l-1.06-1.19s-1.93,1.24-2.79-.73Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M47.9,213.5c.49,1.65-.45,3.37-2.1,3.86s-3.37-.45-3.86-2.1,.45-3.37,2.1-3.86,3.37,.45,3.86,2.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 52.44,
    y: 190.52,
    width: 8.83,
    height: 8.83,
    rx: 1.96,
    ry: 1.96,
    transform: "translate(54.13 -8.1) rotate(15.49)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M463.06,143.55c-1.81,0-3.28-1.47-3.28-3.28v-18.81s.02-.05,.02-.1c0-.05,.01-.1,.03-.14,.02-.05,.03-.09,.06-.13,0,0,.04-.08,.04-.09,0,.01,0,.02,0,.02,0,0,.02-.02,.03-.03,.03-.03,.06-.06,.1-.09,.05-.04,.1-.09,.13-.14l6.05-4.83c.15-.12,.23-.29,.23-.48v-11.14c0-1.27,1.02-2.31,2.28-2.31h23.63c1.26,0,2.28,1.04,2.28,2.31v11.14c0,.19,.08,.36,.23,.48l6.09,4.87s.04,.06,.09,.1c.04,.03,.07,.06,.1,.1,0,0,.06,.06,.07,.07,0,0-.01-.01-.02-.01,0,0,0,.02,.02,.05,.02,.04,.04,.08,.06,.13,.01,.05,.02,.09,.03,.14,0,.06,.02,.11,.03,.15v18.76c0,1.81-1.48,3.28-3.29,3.28h-35.01Zm30.88-5.46c.19,0,.37,.08,.51,.21,.28,.28,.28,.74,0,1.02l-1.73,1.73c-.18,.18-.23,.44-.13,.67,.1,.23,.32,.38,.57,.38h4.91c1.01,0,1.84-.83,1.84-1.84v-16.29c0-.23-.13-.44-.33-.55-.09-.05-.19-.07-.29-.07-.13,0-.25,.04-.35,.11l-15.29,10.59c-1.26,.68-2.19,.96-3.09,.96s-1.83-.28-3.02-.92l-15.36-10.63c-.1-.07-.23-.11-.35-.11-.1,0-.2,.03-.29,.07-.2,.11-.33,.32-.33,.54v16.29c0,1.01,.83,1.84,1.84,1.84h2.24c.16,0,.32-.07,.43-.18l3.62-3.62c.14-.14,.32-.21,.51-.21s.37,.07,.51,.21c.28,.28,.28,.74,0,1.02l-1.73,1.73c-.18,.18-.23,.44-.13,.67,.1,.23,.32,.38,.57,.38h4.24c.16,0,.32-.06,.44-.18l3.62-3.62c.14-.14,.32-.21,.51-.21s.37,.08,.51,.21c.28,.28,.28,.74,0,1.02l-1.73,1.73c-.18,.18-.23,.44-.13,.67,.1,.23,.32,.38,.57,.38h4.24c.16,0,.32-.07,.43-.18l3.62-3.62c.14-.14,.32-.21,.51-.21s.37,.07,.51,.21c.28,.28,.28,.74,0,1.02l-1.73,1.73c-.18,.18-.23,.44-.13,.67,.1,.23,.32,.38,.57,.38h4.24c.16,0,.32-.06,.44-.18l3.62-3.62c.14-.14,.32-.21,.51-.21Zm-25.19-34.67c-.45,0-.84,.4-.84,.87v21.07c0,.2,.1,.39,.26,.51l10.06,6.97c1.02,.54,1.67,.75,2.33,.75s1.31-.21,2.27-.71l10.12-7c.17-.12,.26-.3,.26-.51v-21.07c0-.47-.38-.87-.84-.87h-23.63Zm26.53,14.82c-.09,0-.18,.02-.27,.06-.21,.1-.35,.32-.35,.55v4.64c0,.23,.13,.44,.33,.54,.09,.05,.19,.07,.29,.07,.13,0,.25-.04,.35-.11l3.11-2.15c.16-.11,.26-.29,.26-.49,0-.19-.08-.38-.23-.5l-3.11-2.49c-.11-.09-.25-.13-.38-.13Zm-29.43,0c-.14,0-.28,.05-.38,.13l-3.11,2.49c-.15,.12-.24,.31-.23,.5,0,.19,.1,.37,.27,.48l3.11,2.15c.1,.07,.22,.11,.35,.11,.1,0,.2-.02,.29-.07,.2-.11,.33-.32,.33-.54v-4.64c0-.24-.14-.45-.35-.55-.08-.04-.18-.06-.27-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M477.89,111.45c-.4,0-.72-.32-.72-.72s.32-.72,.72-.72h5.35c.4,0,.72,.32,.72,.72s-.32,.72-.72,.72h-5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M473.88,116.8c-.4,0-.72-.32-.72-.72s.32-.72,.72-.72h13.38c.4,0,.72,.32,.72,.72s-.32,.72-.72,.72h-13.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M473.88,122.15c-.4,0-.72-.32-.72-.72s.32-.72,.72-.72h13.38c.4,0,.72,.32,.72,.72s-.32,.72-.72,.72h-13.38Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 402.31,
    y: 45.77,
    width: 8.83,
    height: 8.83,
    rx: 1.96,
    ry: 1.96,
    transform: "translate(431.42 -358.88) rotate(86.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M401.92,63.96c-.53,.99-1.77,1.37-2.76,.83-.99-.53-1.37-1.77-.83-2.76,.53-.99,1.77-1.37,2.76-.83,.99,.53,1.37,1.77,.83,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M384.9,65.1c-.81,1.51-2.69,2.08-4.2,1.27-1.51-.81-2.08-2.69-1.27-4.2,.81-1.51,2.69-2.08,4.2-1.27,1.51,.81,2.08,2.69,1.27,4.2Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 454.12,
    y: 192.07,
    width: 8.62,
    height: 8.62,
    rx: 1.3,
    ry: 1.3,
    transform: "translate(-40.23 204.12) rotate(-24.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M476.34,192.52c.44,.99,0,2.15-.99,2.59-.99,.44-2.15,0-2.59-.99-.44-.99,0-2.15,.99-2.59s2.15,0,2.59,.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M467.18,210.98c.7,1.56,0,3.4-1.57,4.1-1.56,.7-3.4,0-4.1-1.57-.7-1.56,0-3.4,1.57-4.1,1.56-.7,3.4,0,4.1,1.57Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWebDevelopment);
export default __webpack_public_path__ + "static/media/mobile-web-development.fa9aed6b23b7b1dea1de20d579d69969.svg";
export { ForwardRef as ReactComponent };